import React, { useContext, useEffect, useState } from "react";
import { SCREEN_PATHS } from "../../../constants";
import { Box, Button, Typography } from "@mui/material";
import { ProbateField } from "../../../models/ProbateField";
import { useNavigate } from "react-router";
import { ScreenContentWrapper } from "../../shared/ScreenContentWrapper";
import { ProbateFieldQuestion } from "./ProbateFieldQuestion";
import { probateApi } from "../../../apis";
import { useProbateContext } from "../../../ProbateContextWrapper";
import { Loading } from "../../shared/Loading";
import { useAuthContext } from "AuthContextWrapper"

export const ProbateQuestionScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { activeEstate, user } = useAuthContext()
  const { saveFieldAnsweredInLocalStorage } = useProbateContext()
  const [error, setError] = useState<string>();
  const [screenNumber, setScreenNumber] = useState(1);
  const [skipFields, setSkipFields] = useState<string[]>([]);
  const [currentField, setCurrentField] = useState<ProbateField>();

  useEffect(() => {
    getProbateDetailsAndField();
  }, [screenNumber]);

  const getProbateDetailsAndField = async () => {
    if (activeEstate?.id && user?.id) {
      const probateDetailResponse = await probateApi.getProbateDetails(
        activeEstate.id,
        user?.id
      );
      const unansweredField = probateDetailResponse?.getNextField(skipFields);
      if (!unansweredField) {
        navigate(SCREEN_PATHS.probateReview);
      } else {
        setCurrentField(unansweredField);
      }
    }
  };

  const onAnswer = async (answer: string | number | boolean) => {
    try {
      setError(undefined);
      if (currentField && user?.id) {
        currentField.answerValue = answer;
        // save to db
        await probateApi.saveFieldToKnowledgeEngine(user.id, currentField);
        // save to local field cache - injected as needed later(ProbateDetails.injectPreviouslyAnswered)
        saveFieldAnsweredInLocalStorage(currentField);
        setScreenNumber(screenNumber + 1);
      } else {
        console.error("currentField not determined");
        setError("Sorry, could not determine the field.  Please try again");
      }
    } catch (error) {
      console.error(error);
      setError("Sorry, saving your answer failed.  Please try again");
    }
  };

  return (
    <ScreenContentWrapper
      pageSuffix="Probate"
      title="Get your Probate packet"
      step={1}
      totalSteps={10}
      showBeta={true}
    >
      {currentField ? (
        <Box
          sx={{
            my: 4,
          }}
        >
          <ProbateFieldQuestion field={currentField} onAnswer={onAnswer} />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {error && (
              <Typography color="error" sx={{ my: 2 }}>
                {error}
              </Typography>
            )}
            <Button
              onClick={() => {
                currentField?.id && setSkipFields([...skipFields, currentField.id]);
                setScreenNumber(screenNumber + 1);
              }}
            >
              Skip
            </Button>
          </Box>
        </Box>
      ) : (
        <>
        <Loading />
        </>
      )}
    </ScreenContentWrapper>
  );
};
